export enum PreferredWayOfContact {
  EMAIL = 'EMAIL',
  LETTER = 'LETTER',
}
